import MuiButton from "./../components/basicComponent/MuiButton";
import Header from "./../sharedScreens/Header";
import SideMenu from "./../sharedScreens/menuItems/SideMenu";
import MuiDatePicker from "./../components/basicComponent/MuiDatePicker";
import MuiSearchSelect from "./../components/basicComponent/MuiSearchSelect";
import React, { useState } from "react";

interface CompanyDetails {
  state: string;
  gstNumber: string;
  companyName: string;
  emailId: string;
  phoneNo: string;
  address: string;
  pincode: string;
}

const AddGSTDetails = () => {
  const [active, setActive] = useState<Boolean>(false);
  const [companies, setCompanies] = useState<CompanyDetails[]>([
    {
      state: "",
      gstNumber: "",
      companyName: "",
      emailId: "",
      phoneNo: "",
      address: "",
      pincode: "",
    },
  ]);

  const handleInputChange = (
    index: number,
    field: keyof CompanyDetails,
    value: string
  ) => {
    const newCompanies = [...companies];
    newCompanies[index][field] = value;
    setCompanies(newCompanies);
  };

  const handleAddRow = () => {
    setCompanies([
      ...companies,
      {
        state: "",
        gstNumber: "",
        companyName: "",
        emailId: "",
        phoneNo: "",
        address: "",
        pincode: "",
      },
    ]);
  };

  const handleRemoveRow = (index: number) => {
    const newCompanies = companies.filter((_, i) => i !== index);
    setCompanies(newCompanies);
  };
  return (
    <div className="grow">
      <SideMenu />
      <div className="wrapper flex grow flex-col">
        <Header />
        <main className="grow content" id="content" role="content">
          <div className="container-fixed">
          <div className="card-header mb-1 managebookingg">
              <h3 className="card-title titlecolorr">
              {active ? "Add GST Details " : "View GST Details"}

              </h3>
              <div>
                <button
                  className="fliter-btn me-2"
                  onClick={() => {
                    setActive(!active);
                  }}
                  
                >
                 {active ? "View GST Details" : " Add GST Details "}
                </button>
               
              </div>
            </div>
            <div className="card">
              {active && (
                <>
                  <div className="row">
                    <div className="card-body">
                      <div className="col-md-12">
                        <div className="row mt-3">
                          <div className="col-md-4 mb-3">
                            <MuiSearchSelect
                              label="Business Unit"
                              placeholder={"Business Unit"}
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>

                          <div className="col-md-4 mb-3">
                            <MuiSearchSelect
                              label="Customer Name"
                              placeholder={"Customer Name"}
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                        </div>

                        <div className="user-button w-full">
                          <MuiButton className="clear-btn" label="Clear" />
                          <MuiButton
                            className="get-btn"
                            label="Submit"
                            onClick={() => {}}
                            type="submit"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="container mt-4">
                      <div className="table-responsive">
                        <table className="table table-bordered">
                          <thead className="table-secondary">
                            <tr>
                              <th>State</th>
                              <th>GST Number</th>
                              <th>Company Name</th>
                              <th>Email ID</th>
                              <th>Phone No.</th>
                              <th>Address</th>
                              <th>Pincode</th>
                              <th>Click</th>
                            </tr>
                          </thead>
                          <tbody>
                            {companies.map((company, index) => (
                              <tr key={index}>
                                <td>
                                  <select
                                    className="form-select"
                                    value={company.state}
                                    onChange={(e) =>
                                      handleInputChange(
                                        index,
                                        "state",
                                        e.target.value
                                      )
                                    }
                                  >
                                    <option value="">--Select--</option>
                                    <option value="State1">State1</option>
                                    <option value="State2">State2</option>
                                    <option value="State3">State3</option>
                                  </select>
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={company.gstNumber}
                                    onChange={(e) =>
                                      handleInputChange(
                                        index,
                                        "gstNumber",
                                        e.target.value
                                      )
                                    }
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={company.companyName}
                                    onChange={(e) =>
                                      handleInputChange(
                                        index,
                                        "companyName",
                                        e.target.value
                                      )
                                    }
                                  />
                                </td>
                                <td>
                                  <input
                                    type="email"
                                    className="form-control"
                                    value={company.emailId}
                                    onChange={(e) =>
                                      handleInputChange(
                                        index,
                                        "emailId",
                                        e.target.value
                                      )
                                    }
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={company.phoneNo}
                                    onChange={(e) =>
                                      handleInputChange(
                                        index,
                                        "phoneNo",
                                        e.target.value
                                      )
                                    }
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={company.address}
                                    onChange={(e) =>
                                      handleInputChange(
                                        index,
                                        "address",
                                        e.target.value
                                      )
                                    }
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={company.pincode}
                                    onChange={(e) =>
                                      handleInputChange(
                                        index,
                                        "pincode",
                                        e.target.value
                                      )
                                    }
                                  />
                                </td>
                                <td className="text-center">
                                  {index === companies.length - 1 && (
                                    <button
                                      type="button"
                                      className="btn btn-success btn-sm me-1"
                                      onClick={handleAddRow}
                                    >
                                      +
                                    </button>
                                  )}
                                  {companies.length > 1 && (
                                    <button
                                      type="button"
                                      className="btn btn-danger btn-sm"
                                      onClick={() => handleRemoveRow(index)}
                                    >
                                      -
                                    </button>
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </>
              )}

              {
                !active && (
                  <div className="row">
                  <div className="card-body">
                    <div className="col-md-12">
                      <div className="row mt-3">
                        <div className="col-md-4 mb-3">
                          <MuiSearchSelect
                            label="Business Unit"
                            placeholder={"Business Unit"}
                            options={[]}
                            onChange={function (
                              value: string,
                              id: string,
                              data: any
                            ): void {
                              throw new Error("Function not implemented.");
                            }}
                            value={""}
                          />
                        </div>

                        <div className="col-md-4 mb-3">
                          <MuiSearchSelect
                            label="Customer Name"
                            placeholder={"Customer Name"}
                            options={[]}
                            onChange={function (
                              value: string,
                              id: string,
                              data: any
                            ): void {
                              throw new Error("Function not implemented.");
                            }}
                            value={""}
                          />
                        </div>
                      </div>

                      <div className="user-button w-full">
                        <MuiButton className="clear-btn" label="Clear" />
                        <MuiButton
                          className="get-btn"
                          label="Submit"
                          onClick={() => {}}
                          type="submit"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                )
              }
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default AddGSTDetails;
